<script>
import apiEndpoints from "@/services/apiEndpoints";
import DatePicker from "vue2-datepicker";
import sweetAlert from "@/mixins/sweetAlert";
import systemCode from "@/mixins/systemCode";
import {dateWithWeekDay} from "@/filters";
import user from "@/mixins/user";

export default {
  name: "ModalInquiryDetail",
  mixins: [sweetAlert,systemCode,user],
  components: {
    DatePicker
  },
  data() {
    return {
      inquiry: {},
      replyData: {
        submit_at: '',
        content: ''
      },
      contents: [],
      errors: {},
      isLoading: false
    }
  },
  methods: {
    async getData() {
      if (!this.inquiry.id) return;

      this.isLoading = true;
      const sendApi = await this.$http.get(apiEndpoints.content_inquiries(this.inquiry.id));
      const {status, data} = sendApi;

      if (status && data.result) {
        this.contents = data.result;
      } else {
        this.contents = [];
      }
      this.isLoading = false;
    },
    beforeSubmitReply() {
      this.confirm(
        '',
        '',
        'お問合せへ回答してもよろしいですか。',
        'info',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitReply();
        }
      });
    },
    async submitReply() {
      this.errors = {};

      const url = apiEndpoints.reply_inquiry(this.inquiry.id);
      const {status, data, code} = await this.$http.post(url, this.replyData);
      if (status && data.result.status) {
        this.successToast("お問合せへの回答を登録しました", false, 3000);
        this.$emit('onAnswered', true)
        this.closeModal();
      } else if (status && !data.result.status) {
        return this.errorToast("回答するのに失敗しました");
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    getContentClass(content) {
      const classMap = {
        "1": 'content-bg-green',
        "2": 'content-bg-blue'
      };

      return classMap[content.zz_inquiry_source_id] || '';
    },
    isSeiwaComment(content) {
      return content.zz_inquiry_source_id === "2";
    },
    closeModal() {
      this.$bvModal.hide("modal-inquiry-detail");
    },
    openModal(inquiry) {
      this.inquiry = inquiry;
      this.clearData();
      this.$nextTick(() => this.$bvModal.show("modal-inquiry-detail"))
    },
    formatDateYMD(content) {
      return dateWithWeekDay(content.submit_at, 'YYYY/MM/DD');
    },
    formatCreatedDateYMD(content) {
      return dateWithWeekDay(content.created_at, 'YYYY/MM/DD HH:mm');
    },
    checkReplyAction() {
      const total = this.contents.filter(content => content.zz_inquiry_source_id === '2').length;

      return this.limitReplyInquiry > total
    },
    clearData() {
      this.errors = {};
      this.replyData = {
        submit_at: '',
        content: ''
      };
    }
  },
  computed: {
    limitReplyInquiry() {
      return this.findLimitReceiveReplyInquiry()?.system_code_value;
    }
  }
}
</script>
<template>
  <div class="d-xl-flex">
    <!-- 未回答|回答済み|未回答（再問合せ）-->
    <b-modal
      size="xl"
      id="modal-inquiry-detail"
      centered
      title-class="font-18"
      body-class="p-20"
      hide-footer
      scrollable
      @show="getData"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-end w-100 align-items-center" style="height: 0px;">
          <span style="cursor: pointer;" @click="closeModal">×</span>
        </div>
      </template>
      <b-row>
      <b-overlay
      :show="isLoading"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <b-row style="margin-bottom: 10px;">
        <div class="d-flex">
          <b-col sm="4">
            <span>事業者： {{ inquiry.discharger_name_abbreviated }}</span>
          </b-col>
          <b-col sm="4">
            <span>事業場： {{ inquiry.discharger_site_name_abbreviated }}</span>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <span>問合せ日： {{ inquiry.created_at }}</span>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <div class="d-flex">
            <span>タイトル： {{ inquiry.title }}</span>
          </div>
        </div>
      </b-row>
      <template v-for="(content, index) in contents">
        <b-row class="inquiry-comments" :class="getContentClass(content)">
          <b-row>
            <div class="col-md-4">
              <div class="d-flex">
                <span class="inquiry-content">{{ formatCreatedDateYMD(content) }}{{ content.number_of_comment }}<br>{{ content.content }}</span>
              </div>
            </div>
          </b-row>
          <template v-if="isSeiwaComment(content)">
            <b-row>
              <div class="col-md-4">
                <div class="d-flex">
                  <span class="fw-bold">回答者： </span><span>{{ content.user_name }}</span>
                </div>
              </div>
            </b-row>
          </template>
        </b-row>
      </template>
      <template v-if="inquiry.zz_inquiry_status_id === '1' && checkReplyAction()">
        <b-row class="inquiry-b-row mb-3">
          <b-col sm="1" class="d-flex align-items-center inquiry-col-sm-1">
            <label>対応日</label>
          </b-col>
          <b-col sm="2">
            <date-picker
              lang="ja"
              v-model="replyData.submit_at"
              placeholder="YYYY-MM-DD"
              format="YYYY-MM-DD"
              value-type="YYYY-MM-DD"
              position="left"
              class="manifests-date-picker"
            ></date-picker>
          </b-col>
        </b-row>
        <b-row class="inquiry-b-row" v-if="errors[`submit_at`]">
          <b-col sm="1" class="inquiry-col-sm-1"></b-col>
          <b-col sm="2">
            <div class="error-message">
              {{ errors[`submit_at`][0] }}
            </div>
          </b-col>
        </b-row>
        <b-row class="inquiry-b-row">
          <b-col sm="1" class="d-flex align-items-center inquiry-col-sm-1">
            <label>内容</label>
          </b-col>
          <b-col sm="11">
            <b-form-textarea
              class="w-100"
              v-model="replyData.content"
              id="reply-content-inquiry"
              rows="4"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="inquiry-b-row" v-if="errors[`content`]">
          <b-col sm="1" class="inquiry-col-sm-1"></b-col>
          <b-col sm="11">
            <div class="error-message">
              {{ errors[`content`][0] }}
            </div>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-button
            size="lg"
            variant="primary"
            class="me-2"
            @click="closeModal"
          >
            <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
          </b-button>
          <b-button
            size="lg"
            v-if="inquiry.zz_inquiry_status_id === '1' && checkReplyAction() && canUserEdit()"
            variant="primary"
            class="me-2"
            @click="beforeSubmitReply()"
          >
            <i class='fas fa-check'></i> 回答
          </b-button>
        </div>
      </b-row>
    </b-overlay>
  </b-row>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.inquiry-comments {
  align-items: center;
  gap: 6px;
  margin: 1rem 0px;
  padding: 4px;
}
.content-bg-green {
  background-color: #c4edc4;
}
.content-bg-blue {
  background-color: #c2e5f9;
}
@media (min-width: 576px) {
  .inquiry-col-sm-1 {
    flex: 0 0 auto;
    width: 5.3333333333%;
  }
}
.inquiry-b-row {
  margin-bottom: 10px;
}
.inquiry-content {
  white-space: pre;
}
</style>
